var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"esquerdo"},[_c('ul',{staticClass:"esquerdo"},_vm._l((_vm.programas),function(programa){return _c('li',{key:programa.key},[_c('a',{attrs:{"href":programa.link}},[_vm._v(_vm._s(programa.nome))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a67b7b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RtvFooter.vue
// module id = 35
// module chunks = 0